export enum CardType {
    VISA = 1,
    MasterCard = 2,
    AMEX = 3
}